import onSearch from './onSearch'

const ActivityAction = {
  onSearch
}

export default ActivityAction
